document.addEventListener("DOMContentLoaded", function () {
  // 1. Toggle quantity field for bundle items
  document.querySelectorAll(".bundle-checkbox").forEach((checkbox) => {
    checkbox.addEventListener("change", function () {
      const variantId = this.value;
      const qtyWrapper = document.getElementById(`bundle-qty-${variantId}`);
      qtyWrapper.style.display = this.checked ? "block" : "none";
    });
  });

  // 2. Quantity + / - buttons
  document.querySelectorAll(".quantity-selector").forEach((selector) => {
    const minusBtn = selector.querySelector(".minus");
    const plusBtn = selector.querySelector(".plus");
    const input = selector.querySelector("input");

    minusBtn.addEventListener("click", () => {
      let value = parseInt(input.value) || 1;
      if (value > 1) input.value = value - 1;
    });

    plusBtn.addEventListener("click", () => {
      let value = parseInt(input.value) || 1;
      input.value = value + 1;
    });
  });

  // 3. Intercept Add to Cart button
  const productFormEl = document.querySelector("product-form");
  const form = productFormEl ? productFormEl.querySelector("form") : null;

  if (form) {
    const addToCartBtn = form.querySelector('[type="submit"]');
    
    addToCartBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      const formData = new FormData(form);
      const mainProductId = formData.get("id");
      const mainQty = parseInt(formData.get("quantity") || "1");

      // Create items array with main product
      const items = [{ id: mainProductId, quantity: mainQty }];

      // Add selected bundles
      document.querySelectorAll(".bundle-checkbox:checked").forEach((checkbox) => {
        const variantId = checkbox.value;
        const qtyInput = document.getElementById(`qty_${variantId}`);
        const quantity = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
        items.push({ id: parseInt(variantId), quantity });
      });

      // Submit combined cart via Ajax
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items })
      })
      .then(() => fetch("/cart.js"))
      .then(res => res.json())
      .then(cart => {
        // Open the cart drawer (for the Dawn theme)
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer && typeof cartDrawer.renderContents === "function") {
          cartDrawer.renderContents(cart); // Open the cart drawer
        } else {
          window.location.href = "/cart"; // Fallback if cart drawer is not found
        }
      })
      .catch((err) => {
        console.error("Add to cart error:", err);
        alert("Something went wrong while adding to cart.");
      });
    });
  }
});





